import { CardMenu } from './CardMenu';

export type { TypeCardMenuProps } from './types';
export default CardMenu;
